/* Phatstix quick-add — ONE small global, delegated CLICK handler for any element
   marked [data-ph-quick-add] with a data-variant-id. Used by the cart cross-sell
   ("add another balm" / badge "Add") and the product-card "Quick add" button.

   Deliberately a plain <button>, NOT a <form>: the cart drawer re-renders via
   Alpine.morph, which STRIPS <form> elements (so a form-based add only worked once,
   then vanished). A button survives the morph. And rather than re-hand-roll the cart
   refresh, we fire the theme's OWN events so it behaves exactly like a native add:
     theme:update:cart      -> theme re-fetches + morphs the cart sections
   For the drawer OPEN we can't rely on the theme's theme:open:cart-drawer handler: it's gated on
   settings.cart_type === 'modal', but this store leaves cart_type unset (renders as the right-drawer
   modal anyway), so the gate never fires. We open the modal directly via the Alpine modals store,
   with the theme event as a fallback. */
(function () {
  if (window.__phQuickAddBound) return;
  window.__phQuickAddBound = true;

  // Open the cart drawer the same way the theme does internally, minus the cart_type gate.
  function openCartDrawer() {
    try {
      var modals = window.Alpine && Alpine.store && Alpine.store('modals');
      if (modals && modals.modals && ('cart' in modals.modals) && typeof modals.open === 'function') {
        if (typeof modals.closeAll === 'function') { modals.closeAll(); }
        modals.open('cart');
        return;
      }
    } catch (e) { /* fall through to the event */ }
    document.dispatchEvent(new CustomEvent('theme:open:cart-drawer', { bubbles: true }));
  }

  // Swap the button's label for a spinner, then a tick, then back — so a tap visibly does something.
  // We replace innerHTML (rather than colour:transparent) so the spinner/tick inherit the button's
  // own text colour via currentColor and stay visible on any button skin.
  // The theme's own button is TWO elements: <button class="push-btn"><span class="push-btn__surface">,
  // and the SURFACE carries the fill, radius and border (base.bundle.css:568). Writing innerHTML on
  // the <button> therefore deleted the surface and the button vanished mid-add — measured on the merch
  // PDP, 30 Aug 2026: after click, surfaceStillThere:false and the computed background was
  // rgba(0,0,0,0), leaving a bare spinner over the clouds. Swap the label INSIDE the surface when
  // there is one; fall back to the button for the single-element ph-* buttons. The size lock stays on
  // the BUTTON either way — that is the flex item.
  function labelHost(btn) {
    return (btn && btn.querySelector && btn.querySelector('.push-btn__surface')) || btn;
  }

  function setState(btn, state) {
    if (!btn) return;
    var host = labelHost(btn);
    if (state === 'loading') {
      if (btn.dataset.phLabel == null) {
        btn.dataset.phLabel = host.innerHTML;
        // Pin the box at its EXACT rendered size before the label is swapped out, so the spinner/
        // tick can neither collapse nor grow it. These buttons are flex items (flex:1 1 auto), so
        // `flex:none` is essential — without it, flex re-flows when the label shrinks and the button
        // grows. MEASURE FIRST (while still flex-sized), THEN pin flex:none + that width — measuring
        // after flex:none would read the collapsed content width. border-box so px maps 1:1.
        var lockW = btn.offsetWidth, lockH = btn.offsetHeight;
        btn.style.boxSizing = 'border-box';
        btn.style.flex = 'none';
        btn.style.width = lockW + 'px';
        btn.style.height = lockH + 'px';
      }
      host.innerHTML = '<span class="ph-qa-spin" aria-hidden="true"></span>';
    } else if (state === 'done') {
      host.innerHTML = '<svg class="ph-qa-tick" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>';
    } else if (btn.dataset.phLabel != null) {
      host.innerHTML = btn.dataset.phLabel; delete btn.dataset.phLabel;
      btn.style.width = ''; btn.style.height = ''; btn.style.boxSizing = ''; btn.style.flex = '';   // release the size lock
    }
  }

  function add(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    setState(btn, 'loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { throw data; }              // sold out / error
        setState(btn, 'done');
        document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));  // re-fetch + morph the cart sections
        openCartDrawer();                                                                  // and pop the drawer with it in
        if (btn) { setTimeout(function () { if (!btn.isConnected) return; setState(btn, 'reset'); btn.disabled = false; btn.removeAttribute('aria-busy'); }, 1500); }  /* cart morph may have replaced the node */
      })
      .catch(function () {
        setState(btn, 'reset');
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        var msg = (window.theme && theme.strings && theme.strings.cartError)
                  || document.documentElement.dataset.phAddFailed || 'Could not add to your basket.';
        var er = document.getElementById('cart-errors');
        if (er) { er.textContent = msg; return; }
        /* #cart-errors only exists on the PDP and inside the non-empty cart branch, so on a PLP,
           the homepage trio or the merch band a failed add said NOTHING AT ALL: the spinner stopped
           and the shopper was left assuming it worked. Fall back to the button itself. */
        if (btn) {
          btn.setAttribute('aria-live', 'polite');
          var was = btn.getAttribute('data-ph-label') || btn.textContent;
          btn.setAttribute('data-ph-label', was);
          btn.textContent = msg;
          window.setTimeout(function () { btn.textContent = was; btn.removeAttribute('aria-live'); }, 4000);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-ph-quick-add]') : null;
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();                                       // beat any ancestor card link
    var id = el.getAttribute('data-variant-id');
    if (!id) {                                                 // fallback: a form-wrapped id input
      var f = el.closest('form');
      var i = f && f.querySelector('[name="id"]');
      id = i && i.value;
    }
    if (!id) return;
    var qty = parseInt(el.getAttribute('data-quantity') || '1', 10);
    add(id, qty, el.tagName === 'BUTTON' ? el : null);
  }, true); // capture, so we run before any card-link navigation

  // "Dropping soon" / out-of-stock waitlist is handled by assets/ph-waitlist.js, which opens our
  // OWN modal and posts to Klaviyo's public client endpoint. Deliberately NOT here: two capture-phase
  // listeners on [data-ph-waitlist] would both fire and we'd get Klaviyo's form as well as ours.
})();
